import { render, staticRenderFns } from "./DateModal.vue?vue&type=template&id=0af3e11e&scoped=true"
import script from "./DateModal.vue?vue&type=script&lang=js"
export * from "./DateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af3e11e",
  null
  
)

export default component.exports